/**
 * matchRoute -- Pattern matching utility for route paths.
 *
 * Supports:
 *   - Static segments: "/today"
 *   - Dynamic segments: "/tasks/:id"
 *   - Wildcard: "*"
 *
 * Returns null on no match, or a params object on match.
 */

export function matchRoute(
  pattern: string,
  path: string,
): Record<string, string> | null {
  // Wildcard matches everything
  if (pattern === "*") {
    return {};
  }

  const patternParts = pattern.split("/").filter(Boolean);
  const pathParts = path.split("/").filter(Boolean);

  if (patternParts.length !== pathParts.length) {
    return null;
  }

  const params: Record<string, string> = {};

  for (let i = 0; i < patternParts.length; i++) {
    const pat = patternParts[i]!;
    const val = pathParts[i]!;

    if (pat.startsWith(":")) {
      params[pat.slice(1)] = decodeURIComponent(val);
    } else if (pat !== val) {
      return null;
    }
  }

  return params;
}
